import { ErrorResponse } from '@models/error.response';
import { TranslateService } from '@ngx-translate/core';
import { MainComponent } from '../main/main.component';
import { of, from } from 'rxjs';
import { ActionType } from '@type/action.type';
import { AppConstant } from '@constants/app.constant';
import { NgForm } from '@angular/forms';
import { FormValidationUtil } from '@utils/form.validation';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Component, QueryList, ViewChild, ViewChildren } from '@angular/core';
import swal from 'sweetalert2';
import { switchMap, map, flatMap, filter, toArray, mergeMap, reduce } from 'rxjs/operators';
import { User } from '@app/models/user';
import { AdminUserService } from '@app/services/admin-user-service';
import { NgSelectComponent } from '@ng-select/ng-select';
import { NgSelectUtil } from '@app/utils/ng-select-utils';
import { ModulePathConstant } from '@app/constants/modulePath.constant';
import { CommonService } from '@app/services/common.service';
import { MapObjectUtil } from '@app/utils/map-object-util';
import { OnepageProduct } from '@app/models/onepage-product';
import { ProductService } from '@app/services/product.service';
import { UUID } from 'angular2-uuid';

@Component({
    templateUrl: './product-setup.component.html',
    styleUrls: ['./product-setup.component.scss']
})
export class ProductSetupComponent {
    @ViewChildren(NgSelectComponent) ngSelects: QueryList<NgSelectComponent>;
    selectAll = NgSelectUtil.selectAll
    @ViewChild('workflowForm', { static: false }) workflowForm: NgForm;
    isFieldError = FormValidationUtil.isFieldError;
    action: ActionType;
    loading: boolean = false;
    clickSave: boolean = false;
    isShowAdd:boolean = false;
    isShowUpdate:boolean = false;
    validUser: boolean = true;

    record: OnepageProduct;


    currentUser: User;

    constructor(
        private onepageProductService: ProductService,
        private router: Router,
        private route: ActivatedRoute,
        private mainComponent: MainComponent,
        private commonService: CommonService,
        private translate: TranslateService,
        public appConstant: AppConstant) {
        this.currentUser =   this.commonService.getCurrentUser();
    }

    ngOnInit(): void {
        this.record = new OnepageProduct();
        this.route.params
            .pipe(
                switchMap((params: Params) => {
                    this.loading = true;
                    if (params['id'] === 'new') {
                        this.action = 'CREATE';
                        this.isShowAdd = true;
                    } else {
                        this.action = 'EDIT';
                        this.isShowUpdate = true;
                    }
                    return of(params);
                }),
                switchMap((params: Params) => {
                    if (this.action == 'CREATE') {
                        let form = new OnepageProduct();
                        form.productCode = UUID.UUID().replace(/-/g,'');
                        return of(form);
                    } else {
                        return this.onepageProductService.get(params['id'])
                    }
                })
            )
            .subscribe((workflowForm: OnepageProduct) => {
                this.record = workflowForm;
                this.loading = false;
            });

    }

    save(): void {

        this.clickSave = true;
        //check form for just clicking save without any input
        for (let key of Object.keys(this.workflowForm.controls)) {
            this.workflowForm.controls[key].markAsDirty();
        }

  
        if (!this.validUser) {
            return;
        }

        if (this.workflowForm.valid) {
            switch (this.action) {
                case 'CREATE':
                    this.create();
                    break
                case 'EDIT':
                    this.update();
                    break;
            }
        }
    }
 

    private create(): void {

        this.mainComponent.enableLoadingMask();
        this.loading = true;

        this.onepageProductService.insert(this.record)
            .subscribe(() => {
                this.mainComponent.disableLoadingMask();
                this.loading = false;

                this.router.navigate([ModulePathConstant.PRODUCT_PATH]);

                this.translate.get(ModulePathConstant.PRODUCT_MODULE)
                    .pipe(
                        switchMap(typeStr => this.translate.get(AppConstant.HAS_BEEN_ADDED, { type: typeStr }))
                    )
                    .subscribe(res => {
                        swal.fire({
                            type: 'success',
                            title: res
                        });
                    });
            },
                (error: ErrorResponse) => {
                    this.mainComponent.disableLoadingMask();
                    this.loading = false;
                    from(error.errors)
                        .pipe(
                            mergeMap(error => this.translate.get(error.errorCode)),
                            reduce((acc, value) => acc + value + '<br/>', '')
                        )
                        .subscribe(msg => {

                            this.translate.get(ModulePathConstant.PRODUCT_MODULE)
                                .pipe(
                                    switchMap(typeStr => this.translate.get(AppConstant.FAIL_TO_ADD, { type: typeStr }))
                                )
                                .subscribe(title => {
                                    swal.fire({
                                        type: 'error',
                                        title: title,
                                        html: msg
                                    });
                                });

                        });
                });
    }

    private update(): void {

        this.mainComponent.enableLoadingMask();
        this.loading = true;

        this.onepageProductService.update(this.record)
            .subscribe(record => {
                this.record = record;
                this.mainComponent.disableLoadingMask();
                this.loading = false;

                this.router.navigate([ModulePathConstant.PRODUCT_PATH]);

                this.translate.get(ModulePathConstant.PRODUCT_MODULE)
                    .pipe(
                        switchMap(typeStr => this.translate.get(AppConstant.HAS_BEEN_UPDATED, { type: typeStr }))
                    )
                    .subscribe(res => {
                        swal.fire({
                            type: 'success',
                            title: res
                        });
                    });

            },
                (error: ErrorResponse) => {
                    this.mainComponent.disableLoadingMask();
                    this.loading = false;


                    from(error.errors)
                        .pipe(
                            mergeMap(error => this.translate.get(error.errorCode)),
                            reduce((acc, value) => acc + value + '<br/>', '')
                        )
                        .subscribe(msg => {

                            this.translate.get(ModulePathConstant.PRODUCT_MODULE)
                                .pipe(
                                    switchMap(typeStr => this.translate.get(AppConstant.FAIL_TO_UPDATE, { type: typeStr }))
                                )
                                .subscribe(title => {
                                    swal.fire({
                                        type: 'error',
                                        title: title,
                                        html: msg
                                    });
                                });
                        });
                })

    }

    cancel(): void {
        this.router.navigate([ModulePathConstant.PRODUCT_PATH]);
    }


    isIntegrateWithRabbitchop(): boolean{
        return this.currentUser && this.currentUser.integrateWithRabbitchop=="1";
    }
   
}
